import { Routes } from "@angular/router";
// Nota: Se han eliminado los imports estáticos de los componentes standalone 
// para permitir la carga perezosa (Lazy Loading).
import { AuthGuard } from "./guards/auth.guard";
import { BlankComponent } from "./layouts/blank/blank.component";
import { FullComponent } from "./layouts/full/full.component";
import { SolicitudesDeVisitaRoutes } from "./pages/transacciones/solicitudes-de-visita/solicitudes-de-visita.routes";
import { SolicitudesValidadasRoutes } from "./pages/transacciones/solicitudes-de-visita/solicitudes-validadas/solicitudes-validadas.routes";

export const routes: Routes = [
  {
    path: "",
    redirectTo: "dashboards", // Redirección a ruta protegida
    pathMatch: "full",
  },
  {
    path: "",
    component: FullComponent,
    canActivate: [AuthGuard], // Protección aplicada al Layout principal
    children: [
      {
        path: "dashboards",
        loadChildren: () =>
          import("./pages/dashboards/dashboards.routes").then(
            (m) => m.DashboardsRoutes,
          ),
      },
      {
        path: "reportes",
        loadChildren: () =>
          import("./pages/reportes/reportes.routes").then(
            (m) => m.REPORTES_ROUTES,
          ),
      },     
      {
        path: "transacciones/listado-dinamico",
        loadChildren: () =>
          import(
            "./pages/transacciones/listado-dinamico/listado-dinamico.routes"
          ).then((m) => m.ListadoDinamicoRoutes),
      },
      {
        path: "mantenedores/locales",
        loadChildren: () =>
          import("./pages/mantenedores/locales/locales.routes").then(
            (m) => m.LOCALES_ROUTES,
          ),
      },
      {
        path: "mantenedores/especialidades",
        loadChildren: () =>
          import(
            "./pages/mantenedores/especialidades/especialidades.routes"
          ).then((m) => m.ESPECIALIDADES_ROUTES),
      },
      {
        path: "mantenedores/causa-raiz",
        loadChildren: () =>
          import("./pages/mantenedores/causa-raiz/causa-raiz.routes").then(
            (m) => m.CAUSA_RAIZ_ROUTES,
          ),
      },
      {
        path: "mantenedores/vehiculos",
        loadChildren: () =>
          import("./pages/mantenedores/vehiculos/vehiculos.routes").then(
            (m) => m.VEHICULOS_ROUTES,
          ),
      },
      {
        path: "mantenedores/tecnicos-moviles",
        loadChildren: () =>
          import(
            "./pages/mantenedores/tecnicos-moviles/tecnicos-moviles.routes"
          ).then((m) => m.TECHNICOS_MOVILES_ROUTES),
      },
      {
        path: "mantenedores/tipo-activo",
        loadChildren: () =>
          import("./pages/mantenedores/tipo-activo/tipo-activo.routes").then(
            (m) => m.TIPO_ACTIVO_ROUTES,
          ),
      },
      {
        path: "mantenedores/usuarios",
        loadChildren: () =>
          import("./pages/mantenedores/tecnicos/tecnicos.routes").then(
            (m) => m.TECNICOS_ROUTES,
          ),
      },
      {
        path: "mantenedores/tecnicos-gruman",
        loadChildren: () =>
          import(
            "./pages/mantenedores/tecnicos-gruman/tecnicos-gruman.routes"
          ).then((m) => m.TECNICOS_GRUMAN_ROUTES),
      },
      {
        path: "mantenedores/repuestos",
        loadChildren: () =>
          import("./pages/mantenedores/repuestos/repuestos.routes").then(
            (m) => m.REPUESTOS_ROUTES,
          ),
      },
      {
        path: "mantenedores/clientes",
        loadChildren: () =>
          import("./pages/mantenedores/clientes/clientes.routes").then(
            (m) => m.CLIENTES_ROUTES,
          ),
      },
      {
        path: "mantenedores/documentos",
        loadChildren: () =>
          import("./pages/mantenedores/documentos/documentos.routes").then(
            (m) => m.DOCUMENTOS_ROUTES,
          ),
      },
      {
        path: "mantenedores/tipo-servicio",
        loadChildren: () =>
          import(
            "./pages/mantenedores/tipo-servicio/tipo-servicio.routes"
          ).then((m) => m.TIPO_SERVICIO_ROUTES),
      },
      {
        path: "mantenedores/sectores-trabajo",
        loadChildren: () =>
          import(
            "./pages/mantenedores/sectores-trabajo/sectores-trabajo.routes"
          ).then((m) => m.SECTORES_TRABAJO_ROUTES),
      },
      {
        path: "mantenedores/servicios",
        loadChildren: () =>
          import("./pages/mantenedores/servicios/servicios.routes").then(
            (m) => m.SERVICIOS_ROUTES,
          ),
      },
      {
        path: "mantenedores/lista-de-inspecciones",
        loadChildren: () =>
          import(
            "./pages/mantenedores/lista-de-inspecciones/lista-de-inspecciones.routes"
          ).then((m) => m.LISTA_DE_INSPECCIONES_ROUTES),
      },
      {
        path: "mantenedores/presupuestos",
        loadChildren: () =>
          import("./pages/mantenedores/presupuestos/presupuestos.routes").then(
            (m) => m.PRESUPUESTOS_ROUTES,
          ),
      },
      {
        path: "mantenedores/proveedores",
        loadChildren: () =>
          import("./pages/mantenedores/proveedores/proveedores.routes").then(
            (m) => m.PROVEEDORES_ROUTES,
          ),
      },
      {
        path: "mantenedores/recepciones",
        loadChildren: () =>
          import("./pages/mantenedores/recepciones/recepciones.routes").then(
            (m) => m.RECEPCIONES_ROUTES,
          ),
      },
      {
        path: "mantenedores/programacion-activos",
        loadChildren: () =>
          import(
            "./pages/mantenedores/programacion-activos/programacion-activos.routes"
          ).then((m) => m.PROGRAMACION_ACTIVOS_ROUTES),
      },
      {
        path: "generar-programacion",
        loadChildren: () =>
          import(
            "./pages/transacciones/generar-programacion/generar-programacion.routes"
          ).then((m) => m.GENERAR_PROGRAMACION_ROUTES),
      },
      {
        path: "transacciones/solicitudes-de-visita",
        children: SolicitudesDeVisitaRoutes,
      },
      {
        path: "transacciones/solicitudes-del-dia",
        loadChildren: () =>
          import(
            "./pages/transacciones/solicitudes-del-dia/solicitudes-del-dia.routes"
          ).then((m) => m.SOLICITUDES_DEL_DIA_ROUTES),
      },
      {
        path: "transacciones/solicitudes-del-dia-cliente",
        loadChildren: () =>
          import(
            "./pages/transacciones/solicitudes-del-dia-cliente/solicitudes-del-dia-cliente.routes"
          ).then((m) => m.SOLICITUDES_DEL_DIA_CLIENTE_ROUTES),
      },
      {
        path: "transacciones/solicitudes-de-visita/aprobadas",
        loadChildren: () =>
          import(
            "./pages/transacciones/solicitudes-de-visita/solicitudes-aprobadas/solicitudes-aprobadas.routes"
          ).then((m) => m.SOLICITUDES_APROBADAS_ROUTES),
      },
      {
        path: "transacciones/solicitudes-de-visita/rechazadas",
        loadChildren: () =>
          import(
            "./pages/transacciones/solicitudes-de-visita/solicitudes-rechazadas/solicitudes-rechazadas.routes"
          ).then((m) => m.SOLICITUDES_RECHAZADAS_ROUTES),
      },
       {
        path: "transacciones/solicitudes-de-visita/programadas",
        loadChildren: () =>
          import(
            "./pages/transacciones/solicitudes-de-visita/solicitudes-programadas/solicitudes-programadas.routes"
          ).then((m) => m.SOLICITUDES_PROGRAMADAS_ROUTES),
      },
      {
        path: "transacciones/lista-servicios-realizados",
        loadChildren: () =>
          import(
            "./pages/transacciones/lista-servicios-realizados/lista-servicios-realizados.routes"
          ).then((m) => m.LISTA_SERVICIOS_REALIZADOS_ROUTES),
      },
      {
        path: "mantenedores/cliente-usuarios",
        loadChildren: () =>
          import(
            "./pages/mantenedores/cliente-usuarios/cliente-usuarios.routes"
          ).then((m) => m.CLIENTE_USUARIOS_ROUTES),
      },
      {
        path: "mantenedores/mes-de-facturacion",
        loadChildren: () =>
          import(
            "./pages/mantenedores/mes-de-facturacion/mes-de-facturacion.routes"
          ).then((m) => m.MES_DE_FACTURACION_ROUTES),
      },
      {
        path: "mantenedores/activo-fijo-local",
        loadChildren: () =>
          import(
            "./pages/mantenedores/activo-fijo-local/activo-fijo-local.routes"
          ).then((m) => m.ACTIVO_FIJO_LOCAL_ROUTES),
      },
      {
        path: "transacciones/solicitar-visita",
        loadChildren: () =>
          import(
            "./pages/transacciones/solicitar-visita/solicitar-visita.routes"
          ).then((m) => m.SOLICITAR_VISITA_ROUTES),
      },
      {
        path: "transacciones/listado-programacion",
        loadChildren: () =>
          import(
            "./pages/transacciones/listado-programacion/listado-programacion.routes"
          ).then((m) => m.LISTADO_PROGRAMACION_ROUTES),
      },
      {
        path: "transacciones/solicitud-aprobacion-correctiva",
        loadChildren: () =>
          import(
            "./pages/transacciones/solicitud-aprobacion-correctiva/solicitud-aprobacion-correctiva.routes"
          ).then((m) => m.solicitudAprobacionCorrectivaRoutes),
      },
      {
        path: "transacciones/listado-solicitud-aprobacion-correctiva",
        loadChildren: () =>
          import(
            "./pages/transacciones/listado-solicitud-aprobacion-correctiva/listado-solicitud-aprobacion-correctiva.routes"
          ).then((m) => m.LISTADO_SOLICITUD_APROBACION_CORRECTIVA_ROUTES),
      },
      {
        path: "transacciones/servicios-realizados",
        loadChildren: () =>
          import(
            "./pages/transacciones/servicios-realizados/servicios-realizados.routes"
          ).then((m) => m.SERVICIOS_REALIZADOS_ROUTES),
      },
      {
        path: "transacciones/solicitudes-de-visita/validadas",
        children: SolicitudesValidadasRoutes
      },
      {
        path: "administracion",
        loadChildren: () =>
          import("./pages/administracion/administracion.routes").then(
            (m) => m.ADMINISTRACION_ROUTES
          ),
      },
      {
        path: "starter",
        loadChildren: () =>
          import("./pages/pages.routes").then((m) => m.PagesRoutes),
      },
      {
        path: "ui-components",
        loadChildren: () =>
          import("./pages/ui-components/ui-components.routes").then(
            (m) => m.UiComponentsRoutes,
          ),
      },
      {
        path: "forms",
        loadChildren: () =>
          import("./pages/forms/forms.routes").then((m) => m.FormsRoutes),
      },
      {
        path: "charts",
        loadChildren: () =>
          import("./pages/charts/charts.routes").then((m) => m.ChartsRoutes),
      },
      {
        path: "apps",
        loadChildren: () =>
          import("./pages/apps/apps.routes").then((m) => m.AppsRoutes),
      },
      {
        path: "widgets",
        loadChildren: () =>
          import("./pages/widgets/widgets.routes").then((m) => m.WidgetsRoutes),
      },
      {
        path: "tables",
        loadChildren: () =>
          import("./pages/tables/tables.routes").then((m) => m.TablesRoutes),
      },
      {
        path: "datatable",
        loadChildren: () =>
          import("./pages/datatable/datatable.routes").then(
            (m) => m.DatatablesRoutes,
          ),
      },
      {
        path: "theme-pages",
        loadChildren: () =>
          import("./pages/theme-pages/theme-pages.routes").then(
            (m) => m.ThemePagesRoutes,
          ),
      },
      // --- INICIO CARGA PEREZOSA IMPLEMENTADA ---
      {
        path: "admin/users",
        loadComponent: () => 
          import("./admin/users/users.component").then((m) => m.UsersComponent),
      },
      {
        path: "tecnicos",
        loadChildren: () =>
          import("./pages/mantenedores/tecnicos/tecnicos.routes").then(
            (m) => m.TECNICOS_ROUTES,
          ),
      },
      {
        path: "mantenedores/tecnicos/editar/:id",
        loadComponent: () => 
          import("./pages/mantenedores/tecnicos/editar-tecnico/editar-tecnico.component").then((m) => m.EditarTecnicoComponent),
      },
      {
        path: "changelog",
        loadComponent: () => 
          import("./components/changelog-timeline/changelog-timeline.component").then((m) => m.ChangelogTimelineComponent),
        data: {
          title: "Historial de Actualizaciones",
          urls: [
            { title: "Dashboard", url: "/dashboards/dashboard1" },
            { title: "Historial de Actualizaciones" },
          ],
        },
      },
      {
        path: "busqueda-global",
        loadComponent: () => 
          import("./pages/busqueda-global/busqueda-global.component").then((m) => m.BusquedaGlobalComponent),
        data: {
          title: "Búsqueda Global",
        },
      },
      {
        path: "mantenedores/tipo-solicitud",
        loadChildren: () =>
          import(
            "./pages/mantenedores/tipo-solicitud/tipo-solicitud.routes"
          ).then((m) => m.TIPO_SOLICITUD_ROUTES),
      },
      // --- FIN CARGA PEREZOSA IMPLEMENTADA ---
    ],
  },
  {
    path: "",
    component: BlankComponent,
    children: [
      {
        path: "auth",
        children: [
          // --- INICIO CARGA PEREZOSA AUTH ---
          {
            path: "forgot-password",
            loadComponent: () => 
              import("./components/forgot-password/forgot-password.component").then((m) => m.ForgotPasswordComponent),
          },
          {
            path: "reset-password",
            loadComponent: () => 
              import("./components/reset-password/reset-password.component").then((m) => m.ResetPasswordComponent),
          },
          // --- FIN CARGA PEREZOSA AUTH ---
          {
            path: "",
            loadChildren: () =>
              import("./pages/authentication/authentication.routes").then(
                (m) => m.AuthenticationRoutes,
              ),
          },
        ],
      },
      {
        path: "landingpage",
        loadChildren: () =>
          import("./pages/theme-pages/landingpage/landingpage.routes").then(
            (m) => m.LandingPageRoutes,
          ),
      },
    ],
  },
  {
    path: "**",
    redirectTo: "auth/login",
  },
];